<template>
  <v-card>
    <v-card-text><img src='/static/images/chart.svg' />
      <v-list>
        <v-list-tile>
          <v-list-tile-title>Start Date</v-list-tile-title>
          <v-list-tile-sub-title>May 1, 2017</v-list-tile-sub-title>
        </v-list-tile>
        <v-list-tile>
          <v-list-tile-title>End Date</v-list-tile-title>
          <v-list-tile-sub-title>May 1, 2017</v-list-tile-sub-title>
        </v-list-tile>
      </v-list>
    </v-card-text>
    <v-card-actions>
      <v-btn class="mr-2" color='cyan' dark>
        <v-icon>image</v-icon>{{ $t('Button.ShowasGraph') }}
      </v-btn>
      <v-btn class="mr-2" color='green' dark>
        <v-icon>file_download</v-icon>{{ $t('Button.DownloadRawDatatoExcel') }}
      </v-btn>
      <v-btn color='green darken-2' dark>
        <v-icon class="mr-2">wb_sunny</v-icon>{{ $t('Button.DownloadDailyData') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  export default {}
</script>